module.exports = __webpack_public_path__ + "img/65730.7480463d.png";